<template>
    <div class="chart-container">
      <canvas ref="chartCanvas"></canvas>
    </div>
  </template>
  
  <script>
  import { Chart } from "chart.js";
  
  
  export default {
    name: "NestedDoughnutChart",
    props: {
      typeChart: {
        type: String,
        required: true
      },
      fullStats: {
        type: Object,
        required: true
      },

    },
    data() {
      return {
        statColors : {
          nOfServers: "#6610f2",
          nOfTotalPcs: "#20c997",
          nOfWorkstations: "#17a2b8",
          nPcAvAlert: "#d72935",        // Rosso (alert)
          nPcAvOk: "#28a745",           // Verde (ok)
          nPcDiskAlert: "#e83e8c",      // Rosa (alert disk)
          nPcDiskOk: "#007bff",         // Blu (ok disk)
          nPcMonitored: "#28a745",      // Verde (monitorati)
          nPcOsPatchesAlert: "#ffc107", // Giallo (patches alert)
          nPcOsPatchesOk: "#6f42c1",    // Viola (patches ok)
          nPcUnmonitored: "#d3d3d3" ,    // Grigio (non monitorati)
          nPcMonitored: "#007bff"     // Grigio (non monitorati)
        }
      }
    },
    mounted() {

      const ctx = this.$refs.chartCanvas.getContext("2d");
     
  
      new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: 
            (
            this.typeChart == 'Disk' ? ["OK", "Alert", "Monitored", "Unmonitored"]:
            this.typeChart == 'Security' ? ["Protected", "Unprotected", "Monitored", "Unmonitored"]:
            this.typeChart == 'Backups' ? ["Success", "Some Errors", "Warning", "Unmonitored"]:
            this.typeChart == 'Devices' ? ["Server", "Workstation"]:
              ["Up-to-date", "Pending updates", "Monitored", "Unmonitored"]).map(l => this.$t(l)
            ),
          datasets: [
            {
              label:  this.$t(
                this.typeChart == 'Disk' ? "Devices Disk Status": 
                this.typeChart == 'Security'?"Antivirus Status":
                this.typeChart == 'Devices'?"Devices Type":
                "Backup Operation Status"
              ),
              data:
                this.typeChart == 'Disk' ? 
                [
                this.fullStats.computer_stats.nPcDiskOk, 
                this.fullStats.computer_stats.nPcDiskAlert, 
                0,
                this.fullStats.computer_stats.nPcUnmonitored,
                ] : 
                this.typeChart == 'Security' ? [
                  this.fullStats.computer_stats.nPcAvOk,
                  this.fullStats.computer_stats.nPcAvAlert,
                  0,
                  this.fullStats.computer_stats.nPcUnmonitored,
                ] :
                this.typeChart == 'Backups' ? [
                  this.fullStats.backup_stats.result_ok,
                  this.fullStats.backup_stats.result_error,
                  this.fullStats.backup_stats.result_warning,
                  0
                ] : 
                this.typeChart == 'Devices' ? [
                  this.fullStats.computer_stats.nOfServers,
                  this.fullStats.computer_stats.nOfWorkstations,
                  0,
                  0
                ] : 
                [
                  this.fullStats.computer_stats.nPcOsPatchesOk,
                  this.fullStats.computer_stats.nPcOsPatchesAlert,
                  0,
                  this.fullStats.computer_stats.nPcUnmonitored,
                ],
              backgroundColor: this.typeChart == 'Devices' ? ["#5ebdec", "#253789"] : this.typeChart == 'Backups' ? ["#117757", "#d22437", "#ffc107"] : ["#117757", "#d22437", "#253789", "#d3d3d3"],  
            },
            this.typeChart != 'Backups' && this.typeChart != 'Devices' ? {
              label: "Pc Monitored",
              data: [
                0,
                0,
                this.fullStats.computer_stats.nPcMonitored, 
                this.fullStats.computer_stats.nPcUnmonitored,
                
            ], 
              backgroundColor: ["#117757", "#d22437", "#253789", "#d3d3d3"],  
            }:{}
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          borderWidth:1,
          legend: {
            display:true,
            labels: {
              defaultFontFamily: 'Poppins, Arial, sans-serif',
            } 
           /*  position: "bottom",
            align: "center",*/
          },
          cutoutPercentage: "50",
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex];
                var datasetLabel = dataset.label;
                var dataLabel = data.labels[tooltipItem.index];
                var value = dataset.data[tooltipItem.index];

                // Mostra il tooltip solo per i segmenti con valore > 0
                if (value > 0) {
                  //return datasetLabel + ": " + dataLabel+" (" + value + ")";
                  return  dataLabel+" (" + value + ")";
                }
              }
            }
          }
        },
      });
    },
  };

  
  </script>

  <style scoped>
  .chart-container {
    position: relative;
    width: 100%;
    height: 200px;
    /* o 'auto' se vuoi che si adatti anche in altezza */
  }

  canvas {
    width: 100% !important;
    height: 100% !important;
  }
</style>